// import React from 'react';

// const SludgeDissolution = () => {
//   return (
//     <section className="section light" id="sludge-dissolution">
//       <h2 className="section-title">Sludge Dissolution: The Real Power of MICRO 24</h2>
//       <p className="section-subtitle">
//         MICRO 24 dissolves oil sludge, gum and carbon deposits at a molecular level while
//         your system is running – turning dead stock fuel into usable energy.
//       </p>

//       <div className="sludge-layout">
//         <div className="sludge-panel">
//         {/* Left column – problem narrative */}
//         <div className="sludge-column">
//           <h3 className="sludge-heading">Before MICRO 24 – Sludge Formation Cycle</h3>
//           <ul className="sludge-list">
//             <li>Oil sludge forms when heavy hydrocarbons fail to atomise and ignite fully.</li>
//             <li>Thick layers build up in storage tanks, pipelines, burners and chambers.</li>
//             <li>Fuel flow chokes, flames distort and ignition becomes slow and unreliable.</li>
//             <li>Smoke, soot bursts and frequent shutdowns become part of daily operation.</li>
//           </ul>
//           </div>
//         </div>

//         {/* Middle column – MICRO 24 action */}
//         <div className="sludge-column sludge-column-highlight">
//           <h3 className="sludge-heading">With MICRO 24 – Sludge Elimination Cycle</h3>
//           <ol className="sludge-steps">
//             <li>
//               <strong>Sludge penetration &amp; breakdown</strong>
//               <p>
//                 High‑energy surfactants in MICRO 24 penetrate hardened sludge, break
//                 intermolecular bonds and release it as fine, re‑burnable particles.
//               </p>
//             </li>
//             <li>
//               <strong>Sludge converted back into fuel</strong>
//               <p>
//                 Dissolved sludge re‑enters the fuel stream as micro‑particles with reduced
//                 flash point and shorter chains – ready to ignite instead of sticking.
//               </p>
//             </li>
//             <li>
//               <strong>Clean combustion prevents new sludge</strong>
//               <p>
//                 Smaller, more uniform droplets burn faster and more completely, leaving no
//                 heavy residue behind to start the sludge cycle again.
//               </p>
//             </li>
//           </ol>
//           <div className="sludge-tagline">
//             “MICRO 24 doesn&apos;t mask sludge – it eliminates it.”
//           </div>
//         </div>

//         {/* Right column – infographic-style panels */}
//         <div className="sludge-column">
//           <div className="sludge-panel">
//             <h4>Without MICRO 24</h4>
//             <ul>
//               <li>Thick black/brown sludge on metal surfaces</li>
//               <li>Large fuel droplets bouncing off deposits</li>
//               <li>Smoke‑heavy exhaust and unstable flame</li>
//               <li>Frequent manual cleaning and shutdowns</li>
//             </ul>
//           </div>
//           <div className="sludge-panel sludge-panel-success">
//             <h4>With MICRO 24</h4>
//             <ul>
//               <li>Clean guns, nozzles and heat transfer surfaces</li>
//               <li>Fine uniform droplets and stable bright flame</li>
//               <li>Transparent exhaust, no sludge re‑formation</li>
//               <li>No shutdowns. No manual scraping.</li>
//             </ul>
//           </div>
//         </div>
//       </div>

//       <div className="sludge-bottom-grid">
//         <div className="sludge-bottom-card">
//           <h5>Turns dead fuel into usable energy</h5>
//           <p>Old, settled sludge is reclaimed as burnable fuel instead of being written off.</p>
//         </div>
//         <div className="sludge-bottom-card">
//           <h5>Cleans while the plant runs</h5>
//           <p>MICRO 24 works in‑line – no shutdown, no dismantling, no manual scraping.</p>
//         </div>
//         <div className="sludge-bottom-card">
//           <h5>Protects uptime and maintenance budgets</h5>
//           <p>Clean pathways mean fewer stoppages, fewer overhauls and lower service cost.</p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SludgeDissolution;


import React from "react";

const Icon = {
  Block: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M12 2a10 10 0 1 0 10 10A10.01 10.01 0 0 0 12 2Zm6.5 10a6.47 6.47 0 0 1-1.2 3.75L8.25 6.7A6.5 6.5 0 0 1 18.5 12Zm-13 0a6.47 6.47 0 0 1 1.2-3.75l9.05 9.05A6.5 6.5 0 0 1 5.5 12Z" fill="currentColor"/>
    </svg>
  ),
  Smoke: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M7 20c0-2.5 3-2.5 3-5s-3-2.5-3-5 3-2.5 3-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <path d="M13 20c0-2.5 3-2.5 3-5s-3-2.5-3-5 3-2.5 3-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" opacity="0.9"/>
    </svg>
  ),
  Sludge: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M4 14c2-2 4 2 6 0s4-2 6 0 4 2 4 2v4H4v-6Z" fill="currentColor" opacity="0.9"/>
      <path d="M4 12c2-2 4 2 6 0s4-2 6 0 4 2 4 2" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/>
    </svg>
  ),
  Wrench: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M14.7 6.3a5 5 0 0 0-6.5 6.5L3 18v3h3l5.2-5.2a5 5 0 0 0 6.5-6.5l-2.2 2.2-2.8-2.8 2-2.4Z" fill="currentColor"/>
    </svg>
  ),
  Check: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M9.2 16.6 4.9 12.3l1.4-1.4 2.9 2.9 8-8 1.4 1.4-9.4 9.4Z" fill="currentColor"/>
    </svg>
  ),
  Flame: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M12 2s2 3 2 5-2 3-2 5 3 3 3 6a5 5 0 0 1-10 0c0-4 4-6 5-10 1-2 2-6 2-6Z" fill="currentColor"/>
    </svg>
  ),
  Gauge: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M12 4a9 9 0 0 0-9 9 8.9 8.9 0 0 0 1.7 5.3l1.6-1.2A6.9 6.9 0 0 1 5 13a7 7 0 1 1 14 0 6.9 6.9 0 0 1-1.3 4.1l1.6 1.2A8.9 8.9 0 0 0 21 13a9 9 0 0 0-9-9Z" fill="currentColor" opacity="0.9"/>
      <path d="M13.2 12.8 18 9.5l-4 4.8a2 2 0 1 1-.8-1.5Z" fill="currentColor"/>
    </svg>
  ),
  Droplet: (props) => (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" {...props}>
      <path d="M12 2s7 7.6 7 13a7 7 0 0 1-14 0C5 9.6 12 2 12 2Z" fill="currentColor"/>
    </svg>
  ),
};

const SludgeDissolution = () => {
  return (
    <section className="section dark sludge" id="sludge-dissolution">
      <div className="container">
        <div className="sludge-head">
          <div className="sludge-eyebrow">SLUDGE DISSOLUTION</div>
          <h2 className="sludge-title">The Real Power of MICRO 24</h2>
          <p className="sludge-subtitle">
            Dissolves oil sludge <strong>while the system is running</strong> — reclaiming dead stock fuel and restoring clean fuel pathways.
          </p>
        </div>

        <div className="sludge-grid">
          {/* BEFORE */}
          <div className="sludge-card sludge-before">
            <div className="sludge-card-header">
              <span className="chip chip-bad">Before</span>
              <h3>Sludge Build-Up</h3>
            </div>

            <div className="pipe pipe-dirty">
              <div className="pipe-sludge" />
              <div className="pipe-flow pipe-flow-bad">
                <span className="drop" />
                <span className="drop" />
                <span className="drop" />
              </div>
            </div>

            <div className="facts">
              <div className="fact"><span className="ico"><Icon.Block /></span><span>Choked flow</span></div>
              <div className="fact"><span className="ico"><Icon.Smoke /></span><span>Smoke + soot</span></div>
              <div className="fact"><span className="ico"><Icon.Sludge /></span><span>Deposit layers</span></div>
              <div className="fact"><span className="ico"><Icon.Wrench /></span><span>Frequent cleaning</span></div>
            </div>
          </div>

          {/* ACTION */}
          <div className="sludge-card sludge-action">
            <div className="sludge-card-header center">
              <span className="chip chip-good">MICRO 24 Action</span>
              <h3>Elimination Cycle</h3>
            </div>

            <div className="rail">
              {[
                { t: "Penetrates sludge", s: "Surfactant action breaks sludge bonds" },
                { t: "Dissolves & releases", s: "Turns deposits into micro-particles" },
                { t: "Re-burns as fuel", s: "Reclaimed energy instead of waste" },
                { t: "Prevents re-formation", s: "Cleaner burn stops new deposits" },
              ].map((x, i) => (
                <div className="rail-item" key={i}>
                  <div className="rail-dot">{i + 1}</div>
                  <div className="rail-text">
                    <div className="rail-title">{x.t}</div>
                    <div className="rail-sub">{x.s}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="quote">MICRO 24 doesn’t mask sludge — it eliminates it.</div>
          </div>

          {/* AFTER */}
          <div className="sludge-card sludge-after">
            <div className="sludge-card-header">
              <span className="chip chip-good">After</span>
              <h3>Clean Pathways</h3>
            </div>

            <div className="pipe pipe-clean">
              <div className="pipe-flow pipe-flow-good">
                <span className="micro" />
                <span className="micro" />
                <span className="micro" />
                <span className="micro" />
                <span className="micro" />
              </div>
              <div className="flame" />
            </div>

            <div className="facts">
              <div className="fact"><span className="ico good"><Icon.Check /></span><span>Clean guns/nozzles</span></div>
              <div className="fact"><span className="ico good"><Icon.Flame /></span><span>Stable flame</span></div>
              <div className="fact"><span className="ico good"><Icon.Droplet /></span><span>Better atomization</span></div>
              <div className="fact"><span className="ico good"><Icon.Gauge /></span><span>Higher uptime</span></div>
            </div>
          </div>
        </div>

        {/* Bottom benefit tiles */}
        <div className="sludge-tiles">
          <div className="tile">
            <div className="tile-ico"><Icon.Droplet /></div>
            <div className="tile-title">Reclaims dead stock fuel</div>
            <div className="tile-sub">Sludge becomes burnable energy.</div>
          </div>
          <div className="tile">
            <div className="tile-ico"><Icon.Gauge /></div>
            <div className="tile-title">Cleans while running</div>
            <div className="tile-sub">No shutdown. No scraping.</div>
          </div>
          <div className="tile">
            <div className="tile-ico"><Icon.Wrench /></div>
            <div className="tile-title">Reduces maintenance cost</div>
            <div className="tile-sub">Cleaner systems last longer.</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SludgeDissolution;
